module.exports = __webpack_public_path__ + "static/media/link.ff2305a3.svg";